import * as Yup from 'yup';

export const notificationValidations = Yup.object({
    title: Yup.string().required('Title is required'),
    content: Yup.string().required('Content is required'),
    date: Yup.date().required('Date is required'),
    time: Yup.string().required('Time is required'),
    repeat: Yup.string().required('Repeat option is required'),
});